export default {
    intro: '소리를 듣고, 올바르게 적어보세요!',
    introHandwriting: '소리를 듣고, 손으로 글자를 올바르게 적어보세요!',
    wordIndex: '{index} 번째 단어',
    common: {
        handwritingView: '손글씨 보기',
    },
    student: {
        myAnswer: '내가 제출한 답안',
        noAnswer: '제출한 답안이 없습니다.',
        answer: '정답',
        attemptNumber: '{number}차',
        listen: '귀 기울여 들어보세요!<br />집중해서 들어주세요!',
        teacherReading: '선생님이 직접 읽어주고 있어요',
        listenDirect: '선생님이 직접 읽어주시는 문장을 잘 들어주세요!',
        placeholder: '정답을 입력해주세요.',
        wrongToast: '앗 틀렸어요. 다시 입력해보세요',
        writeEnd: '쓰기 종료',
        submitAnswer: '답안 제출',
        replay: '다시 듣기',
        handwritingPad: {
            progressPrev: '진행바 왼쪽으로 스크롤',
            progressNext: '진행바 오른쪽으로 스크롤',
            cellNav: '{index}번째 칸으로 이동',
            bigWriting: '크게 쓰기',
            eraseCell: '칸 지우기',
            scrollLeft: '왼쪽으로 스크롤',
            scrollRight: '오른쪽으로 스크롤',
            submit: '답안 제출',
            tools: {
                pen: '펜',
                eraser: '지우개',
                clear: '모두 지우기',
            },
        },
        waitingStart: '선생님의 쓰기 시작 신호를 기다려주세요!',
        threeWrong: '3번의 정답 기회를 모두 소진했어요... 선생님이 정답을 공개해 주실 때까지 기다려주세요!',
    },
    teacher: {
        setting: {
            activity: '활동내용',
            number: '번호',
            title: '받아쓰기 📝',
            message: '지금 문장을 재생하면 학생들에게도 들릴 수 있어요!',
            subMessage: '그래도 재생할까요?',
            optionSubMessage: '한 번 재생한 이후에는 확인창이 다시 나오지 않습니다.',
            confirmText: '재생하기',
            addQuestion: {
                button: '문항 추가하기',
                title: '받아쓰기 문항 추가하기',
                guide: '외부에서 복사한 텍스트를 붙여넣을 수 있어요. 한 줄에 한 문항씩 입력해 주세요.',
                notice: '※ 줄바꿈은 다음 문항으로, 띄어쓰기 2칸 이상은 공백으로 처리됩니다.',
                columnQuestion: '추가할 문항',
                cancelConfirm: {
                    title: '입력한 문항을 삭제할까요?',
                    body: '취소하면 지금까지 입력한 문항이 추가되지 않고 모두 삭제됩니다.\n계속하시겠습니까?',
                },
                deleteConfirm: {
                    title: '이 문항을 삭제할까요?',
                    body: '삭제하면 추가한 문항이 목록에서 제거됩니다.\n계속하시겠습니까?',
                },
                registering: '문항을 추가하고 있어요...',
                noticeTitle: '알림',
                emptyData: '문항을 입력해주세요.',
                partialFail: 'TTS 생성 실패로 {count}개 문항이 추가되지 않았습니다.',
                duplicateSkip: '이미 존재하는 문항과 동일하여 {count}개 문항이 추가되지 않았습니다.',
                addFail: '문항 추가에 실패했습니다.',
                deleteFail: '문항 삭제에 실패했습니다.',
                ttsSuccess: 'TTS가 생성되었습니다.',
                ttsFail: 'TTS 생성에 실패했습니다.',
            },
            inputMode: '답안 입력 방식',
            inputModeKeyboard: '키보드',
            inputModeHandwriting: '손글씨',
            tracing: '따라 쓰기',
            allowReplay: '학생이 다시 듣기 가능',
            allowReplayDesc: '*해당 옵션은 학급에 이어폰 또는 헤드셋이 지급되었을 때 사용하는 것을 권장합니다.',
            previewGuide: '를 누르면 미리 들어보실 수 있어요!',
            generateTts: 'TTS 생성',
        },
        handwritingModal: {
            title: '학생별 답안 손글씨',
            answer: '정답',
            notAttempted: '미시도',
        },
        question: '문항',
        intro: '왼쪽 문항에서 단어를 선택해 주세요.',
        ttsStart: '재생 후 쓰기 시작',
        directReading: '직접 읽어주기',
        startWriting: '쓰기 시작',
        completeWriting: '쓰기 완료 및 정답 공개',
        viewStudentResult: '전체 학생 결과 보기',
        toast: {
            alreadyDone: '이미 진행한 단어입니다.',
            fiveSeconds: '쓰기 시작후 5초후에 쓰기 완료 가능합니다.',
        },

        // 결과 페이지
        result: {
            title: '문항별 정답률',
            order: '순서',
            question: '문항',
            answerRate: '정답률',
        },
    },
    table: {
        question: '문제',
        answerRate: '정답률',
        emptyMessage: '내용이 없어요.',
    },
};
